import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";

import {MobileSearchComponent} from "../mobile-search/mobile-search.component";

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    imports: [
    FaIconComponent,
    FormsModule,
    MobileSearchComponent
],
    styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent {
  @Input()
  resultsCount = 0;
  $searchVal = '';
  @Output()
  search = new EventEmitter<string>();

  startSearch(): void {
    this.search.emit(this.$searchVal);
  }

  @Input()
  set searchVal(value: string) {
    this.$searchVal = value;
  }

}
